export const ERROR_TITLE = 'errorPage.error.title';
export const ERROR_TEXT = 'errorPage.error.text';
export const GLOBAL_ERROR_TEXT = 'errorPage.global.error.text';
